import * as React from 'react';

function SvgCommissionBonus(props) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 17" {...props}>
      <path
        d="M6.254 0h39.695a2 2 0 012 2v13a2 2 0 01-2 2H6.254a2 2 0 01-1.713-.967l-3.918-6.5a2 2 0 010-2.066L4.54.967A2 2 0 016.254 0z"
        fill="#fcce01"
        fillRule="evenodd"
      />
    </svg>
  );
}

export default SvgCommissionBonus;
